import EFPicture from '@elem/compCommon/EFPicture';
import { createPortal } from 'react-dom';
import ModalForm from './ModalForm';
import css from './index.module.scss';
import House from './icons/House';
import BMS from './icons/BMS';
import { useGlobal } from '@/utils/useGlobal';

let maskScene: any = null;
export default function P({ freeQuote, freeQuoteBack }: any) {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [active, setActive] = useState(0);
    const [textEnter, setTextEnter] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const SITE_JP = 'jp';

    const items: any[] =
        locale === SITE_JP
            ? [
                  {
                      desc: t('secP_item1_desc'),
                      tab: t('secP_item1_tab'),
                      img: '/responsive/picture/delta-pro-ultra/launch/16_1_jp.jpg',
                      video: '/responsive/video/delta-pro-ultra/launch/16_1_jp.mp4',
                  },
                  {
                      desc: t('secP_item2_desc'),
                      tab: t('secP_item2_tab'),
                      img: '/responsive/picture/delta-pro-ultra/launch/16_2_jp.jpg',
                      video: '/responsive/video/delta-pro-ultra/launch/16_2_jp.mp4',
                  },
                  {
                      desc: t('secP_item3_desc'),
                      tab: t('secP_item3_tab'),
                      img: '/responsive/picture/delta-pro-ultra/launch/16_3_jp.jpg',
                      video: '/responsive/video/delta-pro-ultra/launch/16_3_jp.mp4',
                  },
              ]
            : [
                  {
                      icon: <House />,
                      title: t('secP_item1_title'),
                      desc: t.rich('secP_item1_desc', {
                          n: (text: any) => <span className="no-wrap">{text}</span>,
                      }),
                      tab: t('secP_item1_tab'),
                      img: '/responsive/picture/delta-pro-ultra/launch/16_1',
                  },
                  {
                      icon: <BMS />,
                      title: t('secP_item2_title'),
                      desc: t('secP_item2_desc'),
                      tab: t('secP_item2_tab'),
                      img: '/responsive/picture/delta-pro-ultra/launch/16_2',
                  },
              ];

    const handleChangeTab = (k: number) => {
        setActive(k);
        if (locale === SITE_JP && window?.innerWidth < 768) {
            const tabs = document.querySelector('.dpu-detail-P .tabs') as HTMLElement;
            if (tabs) {
                const { scrollLeft, scrollWidth, offsetWidth } = tabs;
                if (k === 0) {
                    return (tabs.scrollLeft = 0);
                }
                if (k === 1) {
                    return (tabs.scrollLeft = (scrollWidth - offsetWidth) / 2);
                }
                if (k === 2) {
                    return (tabs.scrollLeft = scrollWidth - offsetWidth);
                }
            }
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: items[k].tab,
        });
    };

    const handleOpenForm = () => {
        freeQuoteBack(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: 'EcoFlow DELTA Pro Ultra',
            position: t('secP_btn'),
            option_name: items[active].tab,
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        const resizeAni = () => {
            if (maskScene) AniContainer.removeScene(maskScene);

            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            maskScene = AniContainer.create({
                triggerElement: '.dpu-detail-P',
                triggerHook: 1,
                offset: startH,
                duration: 200, //window.innerHeight * 2,
                onEnter: () => {
                    setTextEnter(true);
                },
                //onLeave: () => setTextEnter(false),
            });
        };
        resizeAni();
    }, []);

    return (
        <section className={`dpu-detail-P dpu-detail-section${textEnter ? ' textEnter' : ''} ${css['dpu-detail-P']}`}>
            {locale === SITE_JP && <p className="subtitle">{t('secP_subtitle')}</p>}
            <h2 className="title">{t('secP_title')}</h2>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item ${locale === SITE_JP ? 'jp' : ''} ${active === k ? 'active' : ''}`} key={k}>
                        <div className="text-box">
                            {item?.icon && <div className="item-icon">{item?.icon}</div>}
                            <div className="item-info">
                                {item?.title && <h2 className="item-title">{item?.title}</h2>}
                                {item?.desc && <p className="item-desc">{item?.desc}</p>}
                            </div>
                        </div>
                        <div className="img-box">
                            {locale !== SITE_JP ? (
                                <EFPicture src={`${item?.img}.jpg`} srcPad={`${item?.img}_768.jpg`} srcMobile={`${item?.img}_768.jpg`} alt={item?.title} />
                            ) : (
                                <video
                                    src={item?.video}
                                    className="img-video"
                                    width="100%"
                                    height="100%"
                                    muted
                                    playsInline
                                    loop
                                    autoPlay
                                    preload="auto"
                                    poster={item?.img}
                                    aria-label={item?.desc}
                                ></video>
                            )}
                            {k === 0 && locale !== SITE_JP && (
                                <>
                                    <p className="note note1">{t('secP_item1_tip1')}</p>
                                    <p className="note note2">{t('secP_item1_tip2')}</p>
                                    <p className="note note3">{t('secP_item1_tip3')}</p>
                                    <p className="note note4">{t('secP_item1_tip4')}</p>
                                </>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items?.map((item: any, k: number) => (
                    <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        {item?.tab}
                    </li>
                ))}
            </ul>
            {locale === SITE_JP && (
                <button className="btn" onClick={handleOpenForm}>
                    {t('secP_btn')}
                </button>
            )}
            {isClient && freeQuote && createPortal(<ModalForm callback={() => freeQuoteBack(false)} />, document.body)}
        </section>
    );
}
